<template>
  <div class="team-picture">
    <v-img
      v-if="!pictureRight"
      :width="pictureSize"
      :height="pictureSize"
      class="team-picture__image"
      alt="home"
      :src="team.pictureUrl"
    />
    <span class="team-picture__name">
      {{ team.name }}
    </span>
    <v-img
      v-if="pictureRight"
      :width="pictureSize"
      :height="pictureSize"
      class="team-picture__image"
      alt="home"
      :src="team.pictureUrl"
    />
  </div>
</template>

<script>
import ProfilePicture from '@/components/User/ProfilePicture.vue';
import Team from '@/models/Team/team';

export default {
  name: 'TeamPicture',
  components: {
    ProfilePicture,
  },
  props: {
    team: {
      type: Team,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    pictureRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pictureSize() {
      return this.small ? '30' : '50';
    },
  },
};
</script>

<style scoped lang="scss">
.team-picture {
  display: flex;
  align-items: center;
  gap: 10px;

  &__image {
    flex-grow: 0;
  }

  &__name {
    font-weight: bold;
    font-size: 1.2em;
  }
}
</style>
